import { render, staticRenderFns } from "./CostFactor.vue?vue&type=template&id=4798897c&scoped=true&"
import script from "./CostFactor.vue?vue&type=script&lang=ts&"
export * from "./CostFactor.vue?vue&type=script&lang=ts&"
import style0 from "./CostFactor.vue?vue&type=style&index=0&id=4798897c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798897c",
  null
  
)

export default component.exports